'use client'

import { ImageHelper } from '@/lib/helpers/image.helper'
import { cn } from '@/lib/utils'
import Image from 'next/image'
import { FC, useEffect, useRef } from 'react'
import brandSliderStyles from './styles/brand-slider.module.css'

interface Brand {
  name: string
  imageUrl: string
}

interface GraphicTeeBrandsProps {
  brands: Brand[]
}

export const GraphicTeeBrands: FC<GraphicTeeBrandsProps> = ({ brands }) => {
  const sliderRef = useRef<HTMLDivElement>(null)

  // Tự động cuộn slideshow
  useEffect(() => {
    if (!sliderRef.current) return

    // Tạo bản sao các phần tử để tạo hiệu ứng vô hạn
    const slider = sliderRef.current
    const slideTrack = slider.querySelector('.slide-track') as HTMLElement

    if (!slideTrack) return

    // Thiết lập animation
    const startAnimation = () => {
      const slideWidth = slideTrack.scrollWidth / 2
      slideTrack.style.transition = 'transform 30s linear infinite'
      slideTrack.style.transform = `translateX(-${slideWidth}px)`
    }

    // Bắt đầu animation sau khi tất cả hình ảnh đã tải
    startAnimation()

    return () => {
      if (slideTrack) {
        slideTrack.style.transition = ''
        slideTrack.style.transform = ''
      }
    }
  }, [brands])

  // Tạo bản sao của brands để tạo hiệu ứng vô hạn
  const duplicatedBrands = [...brands, ...brands]

  return (
    <div className='overflow-hidden py-0' ref={sliderRef}>
      <div
        className={cn(
          brandSliderStyles['slide-track'],
          'flex items-center whitespace-nowrap'
        )}
      >
        {duplicatedBrands.map((brand, index) => (
          <div
            key={index}
            className='mx-4 inline-block transition-opacity hover:opacity-80 md:mx-6'
          >
            <div className='relative h-12 w-24 md:h-16 md:w-32'>
              <Image
                src={ImageHelper.getImageUrlCdn(brand.imageUrl)}
                alt={brand.name}
                fill
                className='object-contain'
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
